import React from 'react'
import { LockUnlockIcon } from '../Distributions/components/permissions'
import styles from '../Distributions/components/Queue/styles'

export const headers = ({ currentStatus, sort, nextStatus, handleFilter, className }) => {
  const isPaidTable = ['deposited_today', 'deposited'].includes(nextStatus)

  const tableHeaders = [
    {
      value: 'BENEFICIARY',
      sort: sort,
      filter: 'beneficiary',
      handleFilter: handleFilter,
      className: className,
      id: 'beneficiary',
    },
    {
      value: 'ACCOUNT',
      sort: sort,
      filter: 'account',
      handleFilter: handleFilter,
      className: className,
      id: 'account',
    },
    {
      value: 'DEPOSIT DATE',
      sort: sort,
      filter: 'deposit_date',
      handleFilter: handleFilter,
      className: className,
      id: 'deposit_date',
    },
    ...(isPaidTable
      ? [
          {
            value: 'DATE ENTERED',
            sort: sort,
            filter: 'date_entered',
            handleFilter: handleFilter,
            className: className,
            id: 'date_entered',
          },
        ]
      : []),
    {
      value: 'DEPOSIT',
      sort: sort,
      filter: 'amount',
      handleFilter: handleFilter,
      className: className,
      id: 'amount',
    },
    {
      value: 'DEPOSIT TYPE',
      sort: sort,
      filter: 'deposit_type',
      handleFilter: handleFilter,
      className: className,
      id: 'deposit_type',
    },
    {
      value: 'FEE EXCEPTIONS',
      sort: sort,
      filter: 'fee_exceptions',
      handleFilter: handleFilter,
      className: className,
      id: 'fee_exceptions',
    },
    ...(!isPaidTable
      ? [
          {
            value: 'SCHEDULE',
            sort: sort,
            filter: 'fee_schedule',
            handleFilter: handleFilter,
            className: className,
            id: 'fee_schedule',
          },
        ]
      : []),
    {
      value: 'ADMIN FEE',
      sort: sort,
      filter: 'admin_fee',
      handleFilter: handleFilter,
      className: className,
      id: 'admin_fee',
    },
    {
      value: 'FEE RATE',
      sort: sort,
      filter: 'fee_rate',
      handleFilter: handleFilter,
      className: className,
      id: 'fee_rate',
    },
    {
      value: 'ENROLL. FEE',
      sort: sort,
      filter: 'enroll_fee',
      handleFilter: handleFilter,
      className: className,
      id: 'enroll_fee',
    },
    {
      value: 'OWNER',
      sort: sort,
      filter: 'owner',
      handleFilter: handleFilter,
      className: className,
      id: 'owner',
    },
    {
      value: 'ID',
      sort: sort,
      filter: 'deposit_id',
      handleFilter: handleFilter,
      className: className,
      id: 'deposit_id',
    },
    {
      value: (
        <div className={styles.lockUnlockIcon}>
          <LockUnlockIcon lockedForEdit={true} />
        </div>
      ),
      sort: sort,
      filter: 'locked_for_edit',
      handleFilter: handleFilter,
      className: className,
      id: 'locked_for_edit',
    },
  ]

  return tableHeaders
}
